import { api2  } from './ApiService';

export default class TopupMobileService {
    
    static async search(key,page,perpage,start_date,end_date) {
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage,
            startDate: start_date,
            endDate: end_date
        }
        let response =  await api2.post(`/api/v1/topup/mobile/search`,data)
        return response.data
    }

}


// WEBPACK FOOTER //
// ./src/service/TopupMobileService.js